<template>
	<div class="container">
		<div v-if="loading">Loading...</div>
		<div v-else>
			<div class="row">
				<!-- SIDEBAR MENU -->
				<div class="col-md-3">
					<profile-menu />
				</div>

				<!-- PRIMARY VIEW CONTAINER -->
				<div class="col-md-9">
					<router-view/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex';

import requireUserLogin from 'frontend/shared/require-user-login';

import ProfileMenu from './ProfileMenu.vue';

export default {
	components: { ProfileMenu },
	mixins: [requireUserLogin],

	data()
	{
		return {
			loading: true,
		}
	},

	mounted()
	{
		this.loading = false;
	}
}
</script>

